module.exports = __webpack_public_path__ + "2-54.jpg?0c33e78ff0da4d553d295508adb79eb9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-54.jpg
// module id = 131
// module chunks = 0